import React, { useContext } from 'react';
import styles from './index.module.scss';
import water_icon from '../../../../imgs/water_icon.png';
import steam_icon from '../../../../imgs/steam_icon.png';
import { Progress, ProgressProps } from 'antd';
import {
  formatThousandUnitDefaultTwo,
  keepPercentTwoNull,
  keepTwoOrNull,
  keepTwoWithNumberOrLine,
} from '@/utils/utils';
import { ShareDataWrapperContext } from '../..';
import { isNil } from 'lodash-es';
import { OverviewDateType } from '@/pages/EnergyStatisticalReport/const';

const twoColors: ProgressProps['strokeColor'] = {
  '0%': '#92ED79',
  '100%': '#59D744',
};

const WaterSteamCard = () => {
  const { overviewData, timeResolution } = useContext(ShareDataWrapperContext);

  return (
    <>
      <div className={styles.water_wrapper}>
        <div className={styles.top}>
          <img className={styles.icon} src={water_icon} alt="" />
          <div className={styles.title}>用水量统计</div>
        </div>
        <div className={styles.bottom}>
          <div className={styles.water_rate_row}>
            {/* 自来水 */}
            <div className={styles.water_rate_item}>
              <div className={styles.water_rate_progress}>
                <Progress
                  type="circle"
                  size={80}
                  percent={
                    !isNil(overviewData?.waterInfo?.tapWaterPlanRatio)
                      ? keepTwoOrNull(overviewData?.waterInfo?.tapWaterPlanRatio)!
                      : undefined
                  }
                  strokeColor={twoColors}
                  trailColor="#28323F"
                  format={() => {
                    return (
                      <span style={{ fontSize: 14 }}>
                        {keepTwoWithNumberOrLine(overviewData?.waterInfo?.tapWaterPlanRatio)}%
                      </span>
                    );
                  }}
                />
              </div>
              <div className={styles.water_rate_text}>
                <div className={styles.item} style={{ backgroundColor: 'rgba(22,221,142,0.05)' }}>
                  <div className={styles.label}>自来水实际用量(m³):</div>
                  <div className={styles.act_value}>
                    {formatThousandUnitDefaultTwo(overviewData?.waterInfo?.tapWaterTotal)}
                  </div>
                </div>
                <div className={styles.item} style={{ backgroundColor: 'rgba(255,203,71,0.1)' }}>
                  <div className={styles.label}>
                    {timeResolution === OverviewDateType.MONTH ? '本月' : '本年'}计划用量(m³):
                  </div>
                  <div className={styles.plan_value}>
                    {formatThousandUnitDefaultTwo(overviewData?.waterInfo?.tapWaterPlan)}
                  </div>
                </div>
              </div>
            </div>
            {/* 分割线 */}
            <div className={styles.dash_vertical}></div>
            {/* 中水 */}
            <div className={styles.water_rate_item}>
              <div className={styles.water_rate_progress}>
                <Progress
                  type="circle"
                  size={80}
                  percent={
                    !isNil(overviewData?.waterInfo?.reclaimedWaterPlanRatio)
                      ? keepTwoOrNull(overviewData?.waterInfo?.reclaimedWaterPlanRatio)!
                      : undefined
                  }
                  strokeColor={twoColors}
                  trailColor="#28323F"
                  format={() => {
                    return (
                      <span style={{ fontSize: 14 }}>
                        {keepTwoWithNumberOrLine(overviewData?.waterInfo?.reclaimedWaterPlanRatio)}%
                      </span>
                    );
                  }}
                />
              </div>
              <div className={styles.water_rate_text}>
                <div className={styles.item} style={{ backgroundColor: 'rgba(22,221,142,0.05)' }}>
                  <div className={styles.label}>中水实际用量(m³):</div>
                  <div className={styles.act_value}>
                    {formatThousandUnitDefaultTwo(overviewData?.waterInfo?.reclaimedWaterTotal)}
                  </div>
                </div>
                <div className={styles.item} style={{ backgroundColor: 'rgba(255,203,71,0.1)' }}>
                  <div className={styles.label}>
                    {timeResolution === OverviewDateType.MONTH ? '本月' : '本年'}计划用量(m³):
                  </div>
                  <div className={styles.plan_value}>
                    {formatThousandUnitDefaultTwo(overviewData?.waterInfo?.reclaimedWaterPlan)}
                  </div>
                </div>
                <div className={styles.extra}>
                  <div className={styles.label}>中水效益:</div>
                  <div className={styles.value}>
                    {keepTwoWithNumberOrLine(overviewData?.waterInfo?.reclaimedWaterRatio)}%
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WaterSteamCard;
